<template>
    <el-card shadow="hover">
        <label slot="header">JImagePreview图片预览</label>
        <el-divider content-position="left">单个图片this.$JImagePreview({ src: url, title: '测试图片' })</el-divider>
        <el-image style="width: 100px; height: 100px" :src="url" @click="$JImagePreview({ src: url, title: '测试图片' })" />
        <el-divider content-position="left">传递图片数组this.$JImagePreview({ srcList: urlList, index: i, listProps: { src: 'url', title: 'name' } })</el-divider>
        <el-image v-for="(image, i) in urlList" style="width: 100px; height: 100px;margin-right: 10px;" :src="image.url" :key="i" @click="$JImagePreview({ srcList: urlList, index: i, listProps: { src: 'url', title: 'name' } })" />
        <el-divider content-position="left">组件方式调用&lt;j-image-preview v-if="show" :close.sync="show" :src="url" /&gt;</el-divider>
        <el-image style="width: 100px; height: 100px" :src="url" @click="show = true" />
        <j-image-preview v-if="show" :close.sync="show" :src="url" />
    </el-card>
</template>

<script>
    import "./JImagePreview"
    import JImagePreview from "./JImagePreview.vue";
    export default {
        name: "JImagePreviewDemo",
        components: {
            JImagePreview
        },
        data() {
            return {
                show: false,
                url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                urlList: [
                    { url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg', name: '测试1' },
                    { url: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg', name: '测试2' },
                    { url: 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg', name: '测试3' },
                ]
            }
        }
    }
</script>
